<div
  class="dz"
  [class.dz--over]="isDragOver()"
  [class.dz--invalid]="status()?.tone === 'error'"
  [class.dz--chosen]="hasFiles()"
  [class.dz--busy]="isUploading()"
  [class.dz--disabled]="isDisabled()">
  <div class="dz-box">
    <button
      type="button"
      class="dz-area"
      [disabled]="isDisabled()"
      [attr.aria-label]="areaLabel()"
      [attr.aria-describedby]="hintId + ' ' + statusId"
      (click)="openPicker()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <svg class="dz-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
        @if (hasFiles()) {
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        } @else {
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z" />
        }
      </svg>
      <span class="dz-title">{{ titleLine() }}</span>
      <span class="dz-meta" [id]="hintId">
        {{ metaLine() }}
        @if (!hasFiles() && !isUploading() && formatsLine()) {
          <span class="dz-formats">{{ formatsLine() }}</span>
        }
      </span>
    </button>

    @if (isUploading()) {
      <div class="dz-progress">
        <app-progress-bar [value]="progressPercentage()" ariaLabel="Upload progress" />
      </div>
    }

    @if (hasFiles() && !isUploading() && !multiple()) {
      <button
        type="button"
        class="dz-remove"
        [disabled]="isDisabled()"
        [attr.aria-label]="'Remove ' + files()[0].name"
        (click)="removeFile(0)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    }
  </div>

  <input
    #fileInput
    type="file"
    class="dz-input"
    tabindex="-1"
    aria-hidden="true"
    [accept]="acceptedTypesString()"
    [multiple]="multiple()"
    (change)="onFileInputChange($event)" />

  @if (multiple() && files().length > 0) {
    <ul class="dz-files" aria-label="Chosen files">
      @for (file of files(); track file.name + '-' + $index; let i = $index) {
        <li class="dz-file">
          <span class="dz-file-name">{{ file.name }}</span>
          <span class="dz-file-size">{{ formatFileSize(file.size) }}</span>
          <button
            type="button"
            class="dz-remove dz-remove--row"
            [disabled]="isDisabled()"
            [attr.aria-label]="'Remove ' + file.name"
            (click)="removeFile(i)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        </li>
      }
    </ul>
  }

  <div class="dz-status-row">
    <p
      class="dz-status"
      [class.dz-status--error]="status()?.tone === 'error'"
      [id]="statusId"
      role="status">
      @if (status(); as s) {
        @if (s.tone === 'error') {
          <svg class="dz-status-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
          <span role="alert">{{ s.text }}</span>
        } @else {
          <span>{{ s.text }}</span>
        }
      }
    </p>
    @if (isUploading()) {
      <button type="button" class="dz-cancel" (click)="cancelUpload()">Cancel upload</button>
    }
  </div>
</div>
